module.exports = __webpack_public_path__ + "img/agent_color.960103c9.png";